export const Labels = {
  InputLabels: {
    oldPassword: "Old Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    Advisor: "Advisor",
    Status: "Status",
    Region: "Region",
    PropertyType: "Property Type",
    PropertySize: "Property Size",
    PriceRange: "Price Range",
    Beds: "Bed(s)",
    Baths: "Bath(s)",
    Furnish: "Furnish",
    ByCode: "By Code",
    Name: "Full Name",
    Mobile: "Mobile",
    Role: "Role",
    Email: "Email Address",
    Active: "Active",
    Landlord: "Landlord",
    Phone: "Phone",
    Fax: "Fax",
    Address: "Address",
    ShopCenter: "Shop Center",
    UnitInFloor: "Unit In Floor",
    Floor: "Floor",
    NumOfFloors: "Number Of Floors",
    Area: "Area (sqm)",
    BuildingAge: "Building Age",
    Renovated: "Renovated",
    DescriptionProperty: "Description About This Property",
    FullFurnished: "Full-Furnished",
    SemiFurnished: "Semi-Furnished",
    MonthlyRent: "Monthly Rent (USD)",
    Kitchen: "Kitchen",
    FloorCover: "Floor Cover",
    TelLine: "Tel Line",
    Advertisement: "Advertisement",
    GarageCount: "Garage Count",
    Storage: "Storage",
    FirePlace: "Fire Place",
    SeoDescription: "SEO Description",
    SeoTitle: "SEO Title",
    Add:'Add',
    Edit:'Edit',
    Item:'Item',
    EngName:'English Name',
    FaName:'Persion Name',
    AddNewItem:'Add New Item',
    ExistItems:'Existing Items',
    EditNewItem:'Edit New Item',
    HotProperty:'Hot Property',
    MonthlyrentAfterDiscount:'Monthly Rent After Discount (USD)',
    Description:'Description',
  },
  ButtonLabels: {
    LOGIN: "Login",
    Waiting: 'Waiting...',
    FORGET_YOUR_PASSWORD: "Forgot your password?",
    SUBMIT: "Submit",
    SEE_ALL_LISTING: "See All Listing",
    SEARCH: "Search",
    ADD_AGENT: "Add Agent",
    EDIT_AGENT: "Edit Agent",
    SELECT_IMAGE: "Select Image",
    ADD_PROPERTY: "Add Property",
    EDIT_PROPERTY: "Edit Property",
    Add:'Add',
    Edit:'Edit',
    Edit_About_us:'Edit About Us',
  },
};
